import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import TimeSlotForm from './ContentForm/TimeSlot/TimeSlotForm'

const TimeSlotModal: React.FC = () => {
  const { handleSubmit, form } = useFormSubmit()
  const { timeSlotsModal, setTimeSlotsModal } = leagueEventStore(store => ({
    timeSlotsModal: store.timeSlotsModal,
    setTimeSlotsModal: store.setTimeSlotsModal,
  }))

  const handleClose = () => {
    setTimeSlotsModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={timeSlotsModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title="Time Slots"
        width={600}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <TimeSlotForm form={form} />
      </CustomModal>
    </>
  )
}

export default TimeSlotModal
